/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const HomeFilled: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="home-filled" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1303.3333333333333 770.6666666666666L1235.2766666666666 681.8133333333334L680 1105.9066666666668V963.3333333333334L1133.3333333333333 617.1V283.3333333333335A113.3333333333333 113.3333333333333 0 0 0 1020 170H226.6666666666667V759.7866666666666L124.3833333333333 681.7L56.6666666666667 770.6666666666666L680 1246.6666666666667L1303.3333333333333 770.6666666666666z" : "M1042.6666666666667 616.5333333333333L988.2213333333334 545.4506666666666L544 884.7253333333333V770.6666666666666L906.6666666666669 493.6799999999999V226.6666666666667A90.6666666666667 90.6666666666667 0 0 0 816 136H181.3333333333334V607.8293333333334L99.5066666666667 545.3599999999999L45.3333333333333 616.5333333333333L544 997.3333333333334L1042.6666666666667 616.5333333333333z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
HomeFilled.displayName = `Blueprint5.Icon.HomeFilled`;
export default HomeFilled;
